import { TrendingHottestItem } from "../shared/type";

/** SNKRDUNK product id from /en/trading-cards/{id} */
export function extractTrendingProductId(
  productNumber: string,
): string | null {
  return productNumber.match(/\/trading-cards\/(\d+)/)?.[1] ?? null;
}

export function trendingItemPathFromProductId(productId: string): string {
  return `/trendingItem/${productId}`;
}

export function trendingItemPathFromItem(item: TrendingHottestItem): string {
  const productId = extractTrendingProductId(item.productNumber);
  return productId ? trendingItemPathFromProductId(productId) : "/trendingItem";
}

export function matchesTrendingProductId(
  item: TrendingHottestItem,
  productId: string | undefined,
): boolean {
  if (!productId) return false;
  return extractTrendingProductId(item.productNumber) === productId;
}
